import { render, staticRenderFns } from "./DeliverySelect.vue?vue&type=template&id=c2147646"
import script from "./DeliverySelect.vue?vue&type=script&lang=js"
export * from "./DeliverySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports